/* eslint-disable no-mixed-spaces-and-tabs */

import React, { useState, useEffect } from 'react';
import logodirect from '../../../assets/img/logoIcon.png';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { useParams, Link } from 'react-router-dom';
import { Col, Row, Card, Image } from 'react-bootstrap';
import FalconLightBoxGallery from 'components/common/FalconLightBoxGallery';
import icon from "../../../assets/img/icons/map-marker.png";
import Background from 'components/common/Background';
import { toast } from 'react-toastify';
import ReactPDF, { Document, Page, Text, View, StyleSheet, PDFViewer, Font, Path, Svg } from '@react-pdf/renderer';
import logo from '../../../assets/img/pdf/logopdf.png';
import Ifumer from '../../../assets/img/logos/interdiction-de-fumer.png'
import NChien from '../../../assets/img/logos/chien.png'
import Lit from '../../../assets/img/logos/lit.png'
import France from '../../../assets/img/country/france.png'
import USA from '../../../assets/img/country/usa.png'
import {
  findIconDefinition
} from '@fortawesome/fontawesome-svg-core'
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'
import "leaflet/dist/leaflet.css";
import Handlee from '../../../assets/fonts/Handlee/Handlee-Regular.ttf';
import Cormorant from '../../../assets/fonts/Cormorant_Garamond/CormorantGaramond-Light.ttf';
import L from "leaflet";
// import Logo from 'components/common/Logo';  
import { API_URL } from 'constants';
import Flex from 'components/common/Flex';

import logoL from '../../../assets/img/BoHouse.png';
import logoIcon from '../../../assets/img/logoIcon.png';


const FontAwesomeIcon = ({ faIcon: { icon }, style = {} }) => {
  const duotone = Array.isArray(icon[4])
  const paths = Array.isArray(icon[4]) ? icon[4] : [icon[4]]
  const color = style.color || 'black'
  return (
    <Svg viewBox={`0 0 ${icon[0]} ${icon[1]}`} style={style}>
      {paths &&
        paths.map((d, index) => (
          <Path
            d={d}
            key={index}
            fill={color}
            fillOpacity={duotone && index === 0 ? 0.4 : 1.0}
          />
        ))}
    </Svg>
  )
}

Font.register({
  family: 'Handlee',
  format: "truetype",
  src: Handlee
});

Font.register({
  family: 'Cormorant',
  format: "truetype",
  src: Cormorant
});


const ViewVilla = ({ logom = false }) => {
  const { id, pdf } = useParams();
  const [formd, setFrom] = React.useState(null);
  const [prep, setPrep] = React.useState(true);
  const [gP1, setGP1] = React.useState(null);
  const [gMap, setGMap] = React.useState(null);
  const [equipements, setEquipements] = React.useState([]);
  const [isFr, setIsFr] = React.useState(true);
  const [english, setEnglish] = React.useState([]);
  const [isReady, setIsReady] = React.useState(false);
  const [isReadyLang, setIsReadyLang] = React.useState(false);


  useEffect(() => {
    if (isReady && isReadyLang && formd && !prep) {
      downloadPDF();
    }
  }, [isReady, isReadyLang, formd, prep])
  const getEn = (text, cb = null) => {
    if (text === null) {
      return
    }
    setPrep(true)
    fetch(`${API_URL}traduction`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: text }),
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log("data",text,  data); 
        let sl = english;
        sl.push({ fr: text, en: data.en });
        setEnglish(sl);
        if (cb) cb(data.en)
        setTimeout(() => {
          setPrep(false)
        }, 7000);
      }).catch(() => {
        setPrep(false)
      })
  }

  function letEn(fr) {
    let r = fr;
    english.forEach(e => {
      if (e.fr === fr) {
        r = e.en;
      }
    })
    return r;
  }

  const GetEquip = (id) => {
    let d = null;
    equipements?.forEach((e) => {
      if (e.id === id) {
        d = e
      }
    })
    return d;
  }

  // Create styles
  const styles = StyleSheet.create({
    pageHome: {
      flexDirection: 'row',
      backgroundColor: 'white',
    },
    view: {

      flexGrow: 1
    },
    section: {
      margin: 20,
      padding: 10,
      flexGrow: 1
    }, image: {
    }, textd: {
      fontSize: 16, color: "black", textAlign: "center",
    },
    text: {
      fontSize: 10
    },
    title: {
      fontSize: 12
    },
    titlen: {
      fontSize: 12,
      color: '#5e5e5e'
    },
    texten: {
      fontSize: 10,
      color: '#5e5e5e'
    },
    table: {
      // borderWidth:1,
      // borderStyle:'solid',
      // borderColor:'grey',
    },
    m: {
      // fontSize:11, 
      padding: 4,
    }, tablel: {
      borderRight: '1px solid #d5d5d5'
    },
    wt: {
      width: 100
    }
  });


  const customIcon = new L.Icon({//creating a custom icon to use in Marker
    iconUrl: icon,
    iconSize: [25, 25],
    iconAnchor: [5, 30]
  });


  function MapView() {
    if (formd?.localisation?.lat && formd?.localisation?.long) {
      let map = useMap();
      map.setView([Number(formd?.localisation?.lat), Number(formd?.localisation?.long)], map.getZoom());

    }
    //Sets geographical center and zoom for the view of the map
    return null;
  }

 
  useEffect(() => {
    if (!id) {
      toast.error('Une erreur s\'est produite.');
      return;
    }

    const fetchData = async () => {
      setPrep(true);

      try {
        // Fetching equipment data
        const equipmentSnapshot = await firebase.firestore().collection('equiments').get();
        const equipments = equipmentSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        setEquipements(equipments);

        // Fetching property data
        const propertyDoc = await firebase.firestore().collection('properties').doc(id).get();
        if (!propertyDoc.exists) throw new Error('Property not found');
        
        const propertyData = propertyDoc.data(); 
        const lat = propertyData.localisation?.lat;
        const long = propertyData.localisation?.long;
const parsedLat = typeof lat === "string" ? parseFloat(lat.replace(",", ".")) : lat || null;
const parsedlong = typeof long === "string" ? parseFloat(long.replace(",", ".")) : long || null;
        const property = {
          ...propertyData,
          id: propertyDoc.id,
          lat: parsedLat,
          long: parsedlong,
          price: propertyData?.priceStart?.price,
          localisation: {
            lat: parsedLat,
            long: parsedlong,
          },
        };

        setFrom(property);

        // Handle gallery data
        if (property.gallery.length > 0 && property.gallery[0] != null) {
          setGP1(property.gallery[0]);
        }

        // Handle exposition and prices
        getEn(property?.exposition?.toUpperCase());
        if (pdf) {
          await Promise.all(
            (property?.prices || [])?.map(async (saison) => {
              const months = (saison?.months || []).map((month, i) => `${month.label}${i + 1 < saison.months.length ? ', ' : ''}`).join('');
              getEn(months);
            })
          );

          const gMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${property?.localisation?.lat},${property?.localisation?.long}&markers=color:red%7C${property?.localisation?.lat},${property?.localisation?.long}&zoom=14&scale=2&size=500x350&key=AIzaSyAd-X1KP-9lIe55bcZeiST7D4mnq9sF-FE`;
          setGMap(gMapUrl);
          toast.warning(isFr ? "Chargement du Pdf en cours, choisir votre langue" : "Loading PDF in progress, choose your language...");

          setIsReady(true);

        } else {
          getEn(property?.vue);
        }

      } catch (error) {
        toast.error(error.message || "Une erreur est survenue");
      } finally {
        setPrep(false);

      }
    };

    fetchData();
  }, [id, pdf]);

  const Normal = () => (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 20,
        paddingRight: 20,
        height: 100,
        alignItems: 'center'
      }}>
        {logom && <img className="me-2" src={logoL} alt="Logo" style={{ height: 20 }} />}
        {/* {logom && <Logo width="100" style={{height: 100}} />}  */}
        {logom && <img className="me-2" src={logoIcon} alt="Logo" style={{ height: 30 }} />}
      </div>

      <FalconComponentCard>
        {
          prep ? <p style={{ margin: 10 }}>Chargement ....</p> : (<>
            {gP1 && (
              <Card.Header
                className={'position-relative min-vh-40 mb-7'}
              >
                <Background image={gP1} className="rounded-3 rounded-bottom-0" />
                <div style={{
                  position: 'relative',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <div className='centered' style={{ marginTop: 100 }}>
                    <h1 style={{ color: 'white ' }}>{formd?.type?.label} {formd?.nameHouse}</h1>
                    <h1 style={{ color: 'white' }}>{isFr ? 'PRIX SUR DEMANDE' : 'PRICES ON REQUEST'}</h1>
                  </div>
                </div>
              </Card.Header>
            )}


            <div class="container">
              <Card.Body style={{ margin: 'auto' }}>
                <FalconLightBoxGallery images={formd?.gallery}>
                  {setImgIndex => (
                    <Row className="g-2">
                      {formd?.gallery?.map((image, i) => {
                        return (
                          <Col xs={4}>
                            <Image
                              className="cursor-pointer"
                              src={image}
                              fluid
                              rounded
                              onClick={() => setImgIndex(i)}
                            />
                          </Col>)
                      })}
                    </Row>
                  )}
                </FalconLightBoxGallery>
              </Card.Body>


              <h2 class="mt-4">{formd?.type?.label} {formd?.nameHouse} • {isFr ? 'PRIX SUR DEMANDE' : 'PRICES ON REQUEST'}</h2>
              <p style={{ whiteSpace: 'break-spaces' }}>{isFr ? formd?.description : formd?.description_en}</p>
              <div class="row mb-3">
                <div class="col-md-4 themed-grid-col mt-4">
                  <div>
                    <h3>{isFr ? 'SURFACES' : 'AREA'}</h3>
                    <table class="listing" style={{ marginBottom: 20 }}>
                      <tbody>
                        {formd?.m2 !== null && formd?.m2 !== undefined && formd?.m2 !== ''&& (<tr>
                          <td style={{ width: 160 }}>1 {isFr ? 'Terrain' : 'Land'}</td>
                          <td style={{ width: 80 }}>{formd?.m2} m²</td>
                          <td></td>
                        </tr>)}
                        <tr>
                          <td style={{ width: 160 }}>{formd?.nbRooms} {isFr ? 'Chambres' : 'Rooms'}</td>
                          <td style={{ width: 80 }}></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td style={{ width: 160 }}>1 {isFr ? 'Cuisine équipée' : 'Fully equipped kitchen'}</td>
                          <td style={{ width: 80 }}></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td style={{ width: 160 }}>{formd?.nbBath} {isFr ? 'Salles de bains' : 'Bathroom'}</td>
                          <td style={{ width: 80 }}></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-4 themed-grid-col mt-4" />
                <div class="col-md-4 themed-grid-col mt-4">
                  <div>
                    <div class="more">
                      <h3>Informations</h3>
                      {isFr ? 'Couchages' : 'Sleeping accommodation'}: {formd?.maxGuest}<br />
                      {isFr ? 'Surface' : 'Surface'}: {formd?.m2habitable} m²<br />
                      {isFr ? 'Exposition' : 'Exhibition'}: {isFr ? formd?.exposition : letEn(formd?.exposition)}<br />
                      {isFr ? 'Vue' : 'View'}: {isFr ? formd?.vue : letEn(formd?.vue)}<br />
                      <h3>{isFr ? 'Prestations' : 'Services'}</h3>
                      <p>
                        {formd?.equipments?.map((e, i) => {
                          return <span>{isFr ? e.label : letEn(e.label)}{formd?.equipments[i + 1] != undefined && ', '}</span>
                        })}
                        .</p>

                    </div>
                  </div>
                </div>
              </div>
              {formd && formd?.localisation?.lat && formd?.localisation?.long && <MapContainer
                className="map"
                center={[Number(formd?.localisation?.lat), Number(formd?.localisation?.long)]}
                zoom={13}
                scrollWheelZoom={true}
              >
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> 
        contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker icon={customIcon} position={[Number(formd?.localisation?.lat), Number(formd?.localisation?.long)]}>
                  <Popup>{formd?.nameHouse}</Popup>
                </Marker>

                <MapView />

              </MapContainer>
              }


              {logom && (<>
                {/* <div class="row mb-3"> */}
                {/* <h3 style={{paddingTop:20 }}>{isFr ? 'VOTRE INTERLOCUTEUR PRIVILÉGIÉ': 'YOUR PERSONAL CONTACT'}</h3> 
        <div class="col-md-5 themed-grid-col mt-4">
            <div>


                <td style={{paddingTop:30 }}>
              <table role="presentation" style={{width:'100%',borderCollapse:'collapse',border:0,borderSpacing:0}}>
                <tr>
                    <td align="center" style={{padding:'0px 0 30px 0'}}>
                        <img class="me-2" src="data:image/jpeg;base64,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" alt="Thomas SABBE" width="150" style={{height:"auto",display:"block"}}/>
                    </td>
                  <td style={{padding:0, paddingTop:10 }} align="right">
                    <p style={{textAlign: 'left'}}>
                        Thomas SABBE<br/>  
                      <a href="mailto:thomas@bo-house.com">thomas@bo-house.com</a><br/>  
                      <a href="tel:+33670317232">+33 6 70 31 72 32</a><br/>
                      {isFr ? 'Langues parlées : anglais, français': 'Languages spoken: English, French'}
                      </p>


                    </td>
                    </tr>
                    </table>
                    </td>
                    
            </div>
        </div> */}
                {/* <div class="col-md-2 themed-grid-col mt-4"></div>
     
      <div class="col-md-5 themed-grid-col mt-4">
      <p style={{textAlign: 'right', paddingTop:30}}>
                  Bo-House<br/>  
4 Rue du Parc des Lices<br/>  
83990 Saint-Tropez<br/>  
France
                    </p>
      </div>  */}
                {/* </div> */}
                <div class="row mb-3">
                  <h3 style={{ paddingTop: 20 }}>ONLINE</h3>
                  <li class="mdi mdi-web" onclick="window.open('https://bo-house.com/');">
                    <a href="https://bo-house.com/" target="_blank">{isFr ? 'Site internet' : 'Website'}</a>
                  </li>
                </div>
              </>)}



              <div class="row mb-3">
                <h3 style={{ paddingTop: 20 }}>{isFr ? 'MENTIONS LÉGALES' : 'LEGAL NOTICES'}</h3>
                <p>{isFr ? 'Informations non contractuelles' : 'Non-contractual information'}<br />
                  {isFr ? 'Des informations sur les risques auxquels ce bien est exposé sont disponibles sur le site Internet de Georisques' : 'Information on the risks to which this property is exposed is available on the Georisques website'}: <a href='www.georisques.gouv.fr' target='_blank'>www.georisques.gouv.fr</a></p>
              </div>

              <div class="row mb-3">
                <h3 style={{ paddingTop: 20 }}>{isFr ? 'RÉGLEMENTATION' : 'REGULATIONS'}</h3>
                {isFr ? (
                  <p>
                    Amiante Réalisé<br />
                    Assainissement Réalisé<br />
                    Coefficient d’emprise au sol Réalisé<br />
                    Coefficient d’occupation au sol Réalisé<br />
                    Électricité Réalisé<br />
                    État des Risques et Pollutions (ERP) Réalisé<br />
                    Gaz Réalisé<br />
                    Normes accessibilité aux personnes handicapées Réalisé<br />
                    Normes relatives à la sécurité incendie Réalisé<br />
                    Plomb Réalisé<br />
                    Termites Réalisé
                  </p>

                ) : (
                  <p>
                    Asbestos Completed<br />
                    Sanitation Completed<br />
                    Floor area ratio Actual<br />
                    Floor area ratio Actual<br />
                    Electricity Completed<br />
                    Risk and pollution assessment (ERP) Completed<br />
                    Gas Actual<br />
                    Standards of accessibility for the disabled Achieved<br />
                    Fire safety standards Achieved<br />
                    Lead Realised<br />
                    Termites Completed
                  </p>
                )}
              </div>
            </div>



          </>)
        }
      </FalconComponentCard>
      {logom &&
        <p style={{ padding: 20, textAlign: 'center' }}>Bo-House • 4 Rue du Parc des Lices • 83990 Saint-Tropez • France<br />
          Non-détention de fonds • SIRET 41750056800072</p>}
    </>
  )

  function splitArrayIntoChunks(array, chunkSize) {
    var result = [];
    for (var i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  }

  // Create Document Component
  const MyDocument = () => (
    <Document>
      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {gP1 && (<ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={gP1} />)}
            <View style={{ height: 60, minWidth: 180, paddingHorizontal: 50, backgroundColor: 'white', marginLeft: 'auto', marginRight: 'auto', marginTop: 70 }}>
              <Text style={[styles.textd, { marginBottom: 25, marginLeft: 'auto', marginRight: 'auto', fontFamily: 'Cormorant', fontSize: 20, position: 'relative', top: 30 }]}>{formd?.nameHouse}</Text>
            </View>
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: -74 }} src={logo} />}
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {formd?.gallery?.length >= 1 && formd?.gallery[1] && (<ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={formd?.gallery?.length >= 1 && formd?.gallery[1]} />)}
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: 50 }} src={logo} />}
          </View>
          <View style={{ backgroundColor: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15 }}>
            <View style={{ position: 'relative' }}>
              <Text style={[styles.textd, { marginBottom: 25, fontFamily: 'Cormorant', fontSize: 15 }]}>{isFr ? 'POINTS CLÉS' : 'KEY POINTS'}</Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'HABITABLE' : 'HABITABLE'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'absolute', top: -20 }}>{formd?.m2habitable} m²</Text></Text>
              {console.log('formd?.m2', formd?.m2)}{formd?.m2 !== null && formd?.m2 !== undefined && formd?.m2 !== '' && (<Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'TERRAIN' : 'PLOT OF LAND'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'relative', bottom: -5 }}>{formd?.m2} m²</Text></Text>)}
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'EXPOSITION' : 'ORIENTATION'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'relative', bottom: -5 }}>{isFr ? formd?.exposition?.toUpperCase() : letEn(formd?.exposition?.toUpperCase())}</Text></Text>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {formd?.gallery?.length >= 2 && formd?.gallery[2] && (<ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={formd?.gallery?.length >= 2 && formd?.gallery[2]} />)}
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: 50 }} src={logo} />}
          </View>
          <View style={{ backgroundColor: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15 }}>
            <View style={{ position: 'relative' }}>
              <Text style={[styles.textd, { marginBottom: 25, fontFamily: 'Cormorant', fontSize: 15 }]}>{isFr ? 'POINTS CLÉS' : 'KEY POINTS'}</Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'CHAMBRES' : 'BEDROOMS'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'absolute', top: -20 }}>{formd?.nbRooms}</Text></Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'SALLES DE BAINS' : 'BATHROOMS'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'relative', bottom: -5 }}>{formd?.nbBath}</Text></Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'CONVIVES' : 'GUESTS'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'relative', bottom: -5 }}>{formd?.maxGuest}</Text></Text>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {formd?.gallery?.length >= 3 && formd?.gallery[3] && (<ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={formd?.gallery?.length >= 3 && formd?.gallery[3]} />)}
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: 50 }} src={logo} />}
          </View>
          <View style={{ backgroundColor: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15 }}>
            <View style={{ position: 'relative' }}>
              <Text style={[styles.textd, { marginBottom: 25, fontFamily: 'Cormorant', fontSize: 15 }]}>DESCRIPTION</Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontFamily: 'Cormorant', fontSize: 12, position: 'absolute', top: -20 }}>{isFr ? formd?.description : formd?.description_en}</Text></Text>
            </View>
          </View>
        </View>
      </Page>


      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {formd?.gallery?.length >= 4 && formd?.gallery[4] && (<ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={formd?.gallery?.length >= 4 && formd?.gallery[4]} />)}
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: 50 }} src={logo} />}
          </View>
          <View style={{ backgroundColor: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15 }}>
            <View style={{ position: 'relative' }}>
              <Text style={[styles.textd, { marginBottom: 25, fontFamily: 'Cormorant', fontSize: 15 }]}>{isFr ? 'TARIF PAR SEMAINE' : 'PRICE PER WEEK'}</Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'absolute', top: -20 }}>{isFr ? 'Sur demande' : 'On request'}</Text></Text>


            </View>
          </View>
        </View>
      </Page>


      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {gMap && formd?.localisation?.lat && formd?.localisation?.long && (<ReactPDF.Link href="_blank" src={`https://maps.google.com/?q=${formd?.localisation?.lat},${formd?.localisation?.long}`}><ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={gMap} /></ReactPDF.Link>)}
          </View>
          <View style={{ backgroundColor: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15 }}>
            <View style={{ position: 'relative' }}>
              <ReactPDF.Link href="_blank" src={`https://maps.google.com/?q=${formd?.localisation?.lat},${formd?.localisation?.long}`}><Text style={[styles.textd, { marginBottom: 25, fontFamily: 'Cormorant', fontSize: 15 }]}>LOCALISATION</Text></ReactPDF.Link>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontWeight: "bold" }}>{isFr ? 'DISTANCE DE LA LOCATION par rapport aux principaux centres d’intérêt' : 'RENTAL DISTANCE from main points of interest'}</Text> · <Text style={{ fontFamily: 'Cormorant', fontSize: 15, position: 'absolute', top: -20 }}>{formd?.distance}</Text></Text>
            </View>
          </View>
        </View>
      </Page>



      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            {formd?.gallery?.length >= 5 && formd?.gallery[5] && (<ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={formd?.gallery?.length >= 5 && formd?.gallery[5]} />)}
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: 50 }} src={logo} />}
          </View>
          <View style={{ backgroundColor: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15 }}>
            <View style={{ position: 'relative' }}>
              <Text style={[styles.textd, { marginBottom: 25, fontFamily: 'Cormorant', fontSize: 15 }]}>{isFr ? 'INFORMATIONS LÉGALES' : 'LEGAL INFORMATION'}</Text>
              <Text style={{ fontSize: 12, textAlign: 'center' }}><Text style={{ fontFamily: 'Cormorant', fontSize: 12, }}>{isFr ? 'Toutes taxes comprises. Photos non contractuelles.' : 'All tax included. Non-contractual pictures.'}</Text></Text>
              {/* <Text  style={{fontSize:12, textAlign:'center', fontWeight:"bold"}}> Caution 15 000 €</Text>  */}
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.pageHome} orientation="landscape" >
        <View style={styles.view} >
          <View style={{ position: 'relative' }}>
            <View style={{ height: 60, minWidth: 180, paddingHorizontal: 50, backgroundColor: 'white', marginLeft: 'auto', marginRight: 'auto', marginTop: 70 }}>
              <Text style={[styles.textd, { marginBottom: 25, marginLeft: 'auto', marginRight: 'auto', fontFamily: 'Cormorant', fontSize: 20, position: 'relative', top: 30 }]}>{isFr ? 'ÉQUIPEMENTS' : 'EQUIPMENTS'}</Text>
            </View>
            {logom && <ReactPDF.Image style={{ height: 25, marginLeft: 'auto', marginRight: 'auto', top: -84 }} src={logo} />}
          </View>


          {splitArrayIntoChunks((formd?.equipments || []), 3)?.map((bequiment) => {
            return <View style={{ padding: 5, paddingHorizontal: 70, position: 'relative', flexDirection: 'row', display: "flex", backgroundColor: 'white', justifyContent: 'space-between' }}>

              {bequiment?.map((e) => {
                return <View style={{ flexDirection: 'row', display: "flex", backgroundColor: 'white', justifyContent: 'left', width: '33%' }}>
                  {/* <ReactPDF.Image style={{height:20, width: 20, borderRadius: 10, border:"1px solid black", padding: 3, marginRight:10}} src={NChien} />    */}
                  {/* <FontAwesomeIcon icon={coffeeIconDefinition} style={{color: '#000',width:30, height:30, fontSize:30}} /> */}

                  {GetEquip(e.value)?.icon ? <View style={{ height: 25, width: 25, borderRadius: 12.5, border: "1px solid green", marginRight: 10, justifyContent: "center", alignItems: 'center' }}>
                    <FontAwesomeIcon faIcon={findIconDefinition({ prefix: 'fa', iconName: GetEquip(e.value)?.icon })} style={{ color: 'black', width: 15, }} />
                  </View> : <View style={{ height: 25, width: 25, borderRadius: 12.5, border: "1px solid green", marginRight: 10, justifyContent: "center", alignItems: 'center' }}>
                    {GetEquip(e.value)?.link && <ReactPDF.Image style={{ height: 15, width: 15, color: '#000' }} src={GetEquip(e.value)?.link} />}
                  </View>}

                  {/* {GetEquip(e.value)?.icon && <FontAwesomeIcon icon={GetEquip(e.value)?.icon} />  */}
                  <Text style={{ fontSize: 12, fontFamily: 'Cormorant' }}>{isFr ? e.label : GetEquip(e.value).titleen}</Text>
                </View>
              })}
            </View>






          })}

          <View style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: 15, paddingHorizontal: 70 }}>
            <View style={{ position: 'relative' }}>
              <View style={{ flexDirection: 'row', display: "flex", backgroundColor: 'white', justifyContent: 'space-between' }}>
                <View style={{ flexDirection: 'row', display: "flex", backgroundColor: 'white', justifyContent: 'center' }}>
                  <ReactPDF.Image style={{ height: 20, width: 20, borderRadius: 10, border: "1px solid black", padding: 3, marginRight: 10 }} src={Ifumer} />
                  <Text style={{ fontSize: 12, fontFamily: 'Cormorant' }}>{isFr ? 'Logement non fumeur' : 'Non-smoking accommodation'}</Text>
                </View>
                <View style={{ flexDirection: 'row', display: "flex", backgroundColor: 'white', justifyContent: 'center' }}>
                  <ReactPDF.Image style={{ height: 20, width: 20, borderRadius: 10, border: "1px solid black", padding: 3, marginRight: 10 }} src={NChien} />
                  <Text style={{ fontSize: 12, fontFamily: 'Cormorant' }}>{isFr ? 'Animaux non autorisés' : 'Pets allowed'}</Text>
                </View>
                <View style={{ flexDirection: 'row', display: "flex", backgroundColor: 'white', justifyContent: 'center' }}>
                  <ReactPDF.Image style={{ height: 20, width: 20, borderRadius: 10, border: "1px solid black", padding: 3, marginRight: 10 }} src={Lit} />
                  <Text style={{ fontSize: 12, fontFamily: 'Cormorant' }}>{isFr ? 'Linge de maison' : 'Household linen'}</Text>
                </View>
              </View>

            </View>
          </View>
        </View>
      </Page>


      {formd?.gallery?.length > 5 && formd?.gallery.map((g, i) => {
        if (i <= 5) return;
        return <Page size="A4" style={styles.pageHome} orientation="landscape" >
          <View style={styles.view} >
            <View style={{ position: 'relative' }}>
              <ReactPDF.Image style={{ width: "100%", height: '100vh', position: 'absolute', top: 0, left: 0, right: 0, bottom: -10 }} src={formd?.gallery?.length >= i && formd?.gallery[i]} />
            </View>
          </View>
        </Page>

      })

      }


    </Document>);

  const [pdfUrl, setPdfUrl] = useState(null);
  function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  const downloadPDF = async () => {

    const blob = await ReactPDF.pdf(<MyDocument />).toBlob();
    const url = URL.createObjectURL(blob);
    if (isMobile()) {
      const a = document.createElement("a");
      a.href = url;
      a.download = `${formd.nameHouse}_${isFr ? 'fr' : 'en'}.pdf`; // Nom du fichier
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } else {
      setPdfUrl(url);
    }
  };


  const Pdf = () => (
    <>
      {formd && !prep ? (<>



        {isReadyLang ? (<>
          {pdfUrl ? <iframe src={pdfUrl} width="100%" height="100%" /> : (
            <div className="loading-container" id='framer'>
              <img src={logodirect} alt="Logo" className="loading-logo" />
            </div>
          )}</>
        ) : (
          <Flex alignItems="center" justifyContent="center" gap={4}>
            <Link
              onClick={() => {
                setIsFr(true);
                setIsReadyLang(true);
              }}
              style={{ textDecoration: 'none', margin: 30 }}
            >
              <Flex alignItems="center">
                <img src={France} alt="Français" />
                <p className="mb-0 ps-3 country text-700">Français</p>
              </Flex>
            </Link>

            <span style={{ width: "2px", height: "20px", backgroundColor: "#ccc" }}></span>

            <Link
              onClick={() => {
                setIsFr(false);
                setIsReadyLang(true);
              }}
              style={{ textDecoration: 'none', margin: 30 }}
            >
              <Flex alignItems="center">
                <img src={USA} alt="Anglais" />
                <p className="mb-0 ps-3 country text-700">Anglais</p>
              </Flex>
            </Link>
          </Flex>

        )}
      </>

      ) : <div className="loading-container" id='framer'>
        <img src={logodirect} alt="Logo" className="loading-logo" />
      </div>}
    </>
  )

  return (
    <>
      <div style={{ backgroundColor: 'white', height: 60, width: '100%', flexDirection: 'row', display: 'flex', justifyContent: !pdf ? 'space-between' : 'end' }}>
        {!pdf && (
          <>
            <Link to={`${window.location.href}/1`} style={{ alignSelf: 'center', marginLeft: 30 }}>
              <Flex alignItems="center">
                <p className="mb-0 ps-3 country text-700">
                  PDF
                </p>
              </Flex>
            </Link>
            {window.location.href.includes('/v/') && (
              <Link to={`${window.location.href.replace("/v/", "/vl/")} `} style={{ alignSelf: 'center', marginLeft: 30 }}>
                <Flex alignItems="center">
                  <p className="mb-0 ps-3 country text-700">
                    Cliquer ici pour sans logo
                  </p>
                </Flex>
              </Link>
            )}

          </>
        )}

        {formd && !prep && !isReadyLang && pdf ? (<>


        </>) : (<>{!isFr ? (<Link onClick={() => {
          setPdfUrl(false)
          setIsReadyLang(false);
          setIsFr(true);
          setTimeout(() => {
            setIsReadyLang(true);
          }, 200);
        }} style={{ marginRight: 30 }}>
          <Flex alignItems="center">
            <img src={France} alt="..." />
            <p className="mb-0 ps-3 country text-700">
              Français
            </p>
          </Flex>
        </Link>) : (<Link onClick={() => {
          setPdfUrl(false)
          setIsReadyLang(false);
          setIsFr(false);
          setTimeout(() => {
            setIsReadyLang(true);
          }, 200);
        }} style={{ marginRight: 30 }}>
          <Flex alignItems="center">
            <img src={USA} alt="..." />
            <p className="mb-0 ps-3 country text-700">
              Anglais
            </p>
          </Flex>
        </Link>)}</>)}


      </div>
      {pdf ? (<Pdf />) : (<Normal />)}

    </>
  );
};

export default ViewVilla;
